import { environment } from '@admin/environments/environment'
import { Injectable } from '@angular/core'
import { BaseReportingConfigProvider, IReportingConfig } from '@engineering11/reporting-web'
import { Store } from '@ngrx/store'
import { getBaseSuffix } from 'shared-lib'
import { selectors } from '../store/selectors'

@Injectable({ providedIn: 'root' })
export class ReportingConfigProvider extends BaseReportingConfigProvider {
  constructor(private store: Store) {
    super()
  }
  get config(): IReportingConfig {
    return {
      reportingBaseURL: environment.services.reporting,
      // Cross-tenant: platform mode posts to platform-reporting and carries no customerKey.
      mode: 'platform',
      token$: this.store.select(selectors.getToken),
      baseSuffix: getBaseSuffix(environment, 'reporting'),
    }
  }
}
